/*
 * @Author: limin
 * @Date: 2018-06-25 10:28:18
 * @Last Modified by: huyue
 * @Last Modified time: 2021-07-16 18:02:05
 */
import axios from 'axios'
import qs from 'qs'
// 创建axios实例
const service = axios.create({
  withCredentials: true
})
// request拦截器
service.interceptors.request.use(
  config => {
    try {
      const { whiteList } = service.customer
      // config.baseURL = baseURL
      // config.timeout = timeout
      // config.headers['TGT'] = configFactory().TGT
      config.transformRequest = [
        function(data) {
          if (config.requestType === 'jsonString') {
            return JSON.stringify(data)
          }
          return qs.stringify(data)
        }
      ]
      if (
        !config.retry &&
        !config.url.endsWith('admin-operating-auth/menu/findTree')
      ) {
        // 重新请求 和 获取权限不鉴权
        // const resources = GetConfigByKey(AppConst.Auth.Resources.Key) //TODO URL鉴权
        if (whiteList.length && !whiteList.some(url => url === config.url)) {
          // 拦截请求
          return Promise.reject({
            message: `${config.url} 无访问权限，请联管理员`
          })
        }
      }
    } catch (error) {
      return Promise.reject(error)
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)
// respone拦截器
service.interceptors.response.use(
  response => {
    const { result } = service.customer
    const res = response.data
    let code, errId
    try {
      code = res[result.code_key || 'returnCode'] // 返回值状态码
      errId = res[result.errId || 'errId']
    } catch (error) {
      return Promise.reject(error)
    }
    if (!code && !errId && code === undefined) {
      return Promise.reject(res)
    }
    if (+errId === -200) {
      if (
        response.config.requestType === 'jsonString' &&
        typeof response.config.data === 'string'
      ) {
        // 重新请求将处理过的json字符串参数还原 因为再次请求会重新处理一遍
        response.config.data = JSON.parse(response.config.data)
      }
      response.config.retry = true
      return service(response.config)
    }
    if (errId + '' === result.errId_logout_value + '' || code + '' === result.errId_logout_value + '') {
      // window.vm && window.vm.$parent_iframe && window.vm.$parent_iframe.to('login')
      window.parent.postMessage({
        type: 'logout'}, '*');
    }
    if (+code !== +result.code_success_value) {
      // 比对配置的成功状态码与返回状态码 如果不成功 则读取配置的错误信息映射
      const cmm = result.code_message_map
      const msg =
        cmm[errId] ||
        cmm[code] ||
        res[result.message_key || 'message'] ||
        '返回错误.'
      return Promise.reject(msg)
    } else {
      if (result.return_all) {
        return res
      }
      // 成功 则返回成功消息体
      return res[result.data_key || 'data']
    }
  },
  error => {
    return Promise.reject(error)
  }
)
service.init = function(options = {}) {
  const { result = {}, whiteList = [], baseURL, timeout = 3000, headers } = options
  service.customer = {
    result,
    whiteList
  }
  Object.assign(service.defaults, { headers }, { baseURL, timeout })
}
export default service
